import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: { title: 'Daniel Vargas' },
	},
	{
		path: '/projects/:code',
		name: 'Single Project',
		component: () =>
			import(/* webpackChunkName: "project" */ '../views/SingleProject.vue'),
		meta: { title: 'Daniel Vargas - Project' },
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
	scrollBehavior(to) {
		if (to.hash) {
			return { el: to.hash, behavior: 'smooth' };
		}
		return { top: 0 };
	},
});

router.beforeEach((to, from, next) => {
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);
	if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
	next();
});

export default router;
